import axios from "axios";
import React from "react";
import { useConfirm } from "material-ui-confirm";
import { useNavigate } from "react-router-dom";
import MenuLink from "./MenuLinkComponent";

const MenuSairComponent = (props:any) => {
	const navigate = useNavigate();
	const confirm = useConfirm();

	const sairClick = async () => {
		await confirm({ title: "Deseja realmente sair?" });
		
		let preferences = {'darkMode':0};
		localStorage.setItem("preferences", JSON.stringify(preferences));

		document.documentElement.setAttribute("data-theme", 'light');

		await axios.post('sair');
		navigate('/login');
		window.location.reload();
	};

	return (
		<div>
			<MenuLink title="Sair" iconClass={props.iconClass} styleClass={props.styleClass} customClick={sairClick} />
		</div>
	);
}

export default MenuSairComponent;